@if (building) {
  <div id="driver-metrics" class="driver-container">
    <div class="content">
      <div class="filter-panel">
        <div class="filter-content">
          <app-adm-filter [building]='building'></app-adm-filter>
        </div>
      </div>
    </div>
    <div class='flex justify-center'>
      <app-driver-metrics-table [building]="building"></app-driver-metrics-table>
    </div>
  </div>
}
